import React, { FC } from 'react';
import { cx } from 'emotion';
import { useStyles } from './styles';

export interface RadioProps {
  checked: boolean;
  inverse?: boolean;
  size?: 'small' | 'medium';
  rippleAnimationDuration?: number;
}

const Radio: FC<RadioProps> = ({
  checked,
  inverse,
  size,
  rippleAnimationDuration
}) => {
  const styles = useStyles([checked, inverse, size, rippleAnimationDuration]);

  return (
    <div className={styles.radio}>
      <div className={cx('Radio_border', styles.border)} />
      <div className={styles.dot} />
      {checked && <div className={cx(styles.border, styles.borderAnimation)} />}
    </div>
  );
};

Radio.defaultProps = {
  inverse: false,
  size: 'medium',
  rippleAnimationDuration: 300
};

export default Radio;
